import { Product } from 'apps/shared/src/models';

export const expatNotInUkFilterTitle = 'Expat not in UK';
export const greenEcoFilterTitle = 'Green/eco products';
export const offsetFilterTitle = 'Offset Mortgage';
export const secondResidentialFilterTitle = 'Second Residential';
export const regulatedBTLFilterTitle = 'Regulated BTL';

export const expatNotInUkFilterValue = 'expatNotInUk' satisfies keyof Product;
export const greenEcoFilterValue = 'greenEco' satisfies keyof Product;
export const offsetFilterValue = 'offset' satisfies keyof Product;
export const secondResidentialFilterValue = 'secondResidential' satisfies keyof Product;
export const regulatedBTLFilterValue = 'regulatedBuyToLet' satisfies keyof Product;

export const hmoFilterValue = 'hmo' satisfies keyof Product;
export const limitedCompanyPurchaseFilterValue = 'hmo' satisfies keyof Product;
export const multiUnitFreeholdBlockFilterValue = 'multiUnitFreeholdBlock' satisfies keyof Product;
export const newBuildFilterValue = 'newBuild' satisfies keyof Product;
export const portfolioLandlordFilterValue = 'portfolioLandlord' satisfies keyof Product;
export const jointBorrowerSoleProprietorFilterValue = 'jointBorrowerSoleProprietor' satisfies keyof Product;
export const retirementInterestOnlyFilterValue = 'retirementInterestOnlyRio' satisfies keyof Product;
export const rightToBuyFilterValue = 'rightToBuy' satisfies keyof Product;
export const selfBuildFilterValue = 'selfBuild' satisfies keyof Product;
export const sharedEquityFilterValue = 'sharedEquity' satisfies keyof Product;
export const sharedOwnershipFilterValue = 'sharedOwnership' satisfies keyof Product;
